import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex min-h-screen w-full flex-col"
}

import { SidebarProvider } from '@/components/ui/sidebar';
    import { usePage } from '@inertiajs/vue3';
    import { SharedData } from '@/types';

    interface Props {
        variant?: 'header' | 'sidebar';
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AppShell',
  props: {
    variant: {}
  },
  setup(__props: any) {

    

    const isOpen = usePage<SharedData>().props.sidebarOpen;

return (_ctx: any,_cache: any) => {
  return (_ctx.variant === 'header')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
    : (_openBlock(), _createBlock(_unref(SidebarProvider), {
        key: 1,
        "default-open": _unref(isOpen)
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["default-open"]))
}
}

})